import { componentProvider } from 'js-component-framework/es';
import breakpoints from '@/js/utils/breakpoints';
import PopOver from '@/js/PopOver';
import ToggleButton from '@/js/ToggleButton';

/**
 * MenuBarToggle component.
 */
class MenuBarToggle {
  /**
   * Start the component
   */
  constructor({ children, element, options }) {
    this.children = children;
    this.element = element;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);

    this.init();
  }

  /**
   * Set up the PopOver.
   */
  init() {
    if (breakpoints.lgMin.matches) {
      // Popover for large screens.
      if (this.toggle instanceof ToggleButton) {
        this.toggle.destroy();
      }

      this.toggle = new PopOver(this.element);
    } else {
      // ToggleButton for small screens.
      if (this.toggle instanceof PopOver) {
        this.toggle.destroy();
      }

      this.toggle = new ToggleButton(this.element);
    }
  }
}

const menuBarToggleConfig = {
  name: 'menu-bar-toggle',
  component: MenuBarToggle,
};

componentProvider(menuBarToggleConfig);
